import { useIsEpochTimeInPast } from "./useIsEpochTimeInPast.js";


export function useIsEpochTimeInFuture(timeMs: number): boolean {
    const inPast = useIsEpochTimeInPast(timeMs);
    return !inPast;
}
